import PropTypes from "prop-types"
import { IconButton, Tooltip } from "@mui/material"
import { Create } from "@mui/icons-material"
import ForecastInformation from "components/forecast-selector/information"

export default function ForecastSelector({ forecast, openForecastEdit, isOpPro }) {
  return <div className="forecast-wrapper">
    <ForecastInformation {...{ selectedForecast: forecast, isOpPro }} />
    <div className="forecast-edit">
      <Tooltip title="Edit">
        <IconButton onClick={openForecastEdit} size="large">
          <Create />
        </IconButton>
      </Tooltip>
    </div>
  </div>
}

ForecastSelector.propTypes = {
  forecast: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  openForecastEdit: PropTypes.func.isRequired,
  isOpPro: PropTypes.bool.isRequired,
}
